export function isRoomHostOrAdmin({ hubChannel, isAdmin = false } = {}) {
  if (isAdmin) {
    return true;
  }

  if (!hubChannel) {
    return false;
  }

  if (typeof hubChannel.canOrWillIfCreator === "function" && hubChannel.canOrWillIfCreator("update_hub")) {
    return true;
  }

  return typeof hubChannel.can === "function" && hubChannel.can("update_hub");
}

export function getRoomEntryAccessState({
  slug,
  isInTheEvent,
  hasEventConcluded,
  timeLeft,
  userCanBypassEventGate = false
}) {
  const hasEventStarted = !timeLeft;
  const userHasRSVPed = isInTheEvent === true;
  const userHasNotRSVPed = isInTheEvent === false;
  const canAccessEvent = !slug || userHasRSVPed || hasEventConcluded || userCanBypassEventGate;
  const canJoinEventNow = hasEventStarted || userCanBypassEventGate;

  return {
    hasEventStarted,
    userHasRSVPed,
    userHasNotRSVPed,
    canAccessEvent,
    canJoinEventNow
  };
}

// Canonical public and unlisted Event lobbies render the RSVP and admission
// experience inside the room entry dialog. Reticulum's legacy gate must not
// preempt that dialog. Keep the legacy gate for private, session, legacy, and
// not-yet-reconciled Event Rooms.
export function requiresLegacyEventEntryGate({ roomRole, visibility, eventVisibility } = {}) {
  const canonicalVisibility = ["private", "unlisted", "public"].includes(eventVisibility)
    ? eventVisibility
    : visibility;

  return roomRole !== "lobby" || (canonicalVisibility !== "public" && canonicalVisibility !== "unlisted");
}

export function shouldRedirectTimedEventRoom({ startTime, endTime, userCanBypassEventGate = false, now = Date.now() }) {
  if (userCanBypassEventGate) {
    return false;
  }

  return startTime >= now || endTime < now;
}
